import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityTecnicoResponsableAddFailure,
  entityTecnicoResponsableAddRequest,
  entityTecnicoResponsableAddSuccess,
  entityTecnicoResponsableChangeRequest, entityTecnicoResponsableChangeSuccess, entityTecnicoResponsableLoadFailure, entityTecnicoResponsableLoadRequest, entityTecnicoResponsableLoadSuccess
} from './entity-tecnico-responsable.actions';

import { Update } from '@ngrx/entity';

import { NotificationService } from '../../../core/core.module';
import { TecnicoResponsable } from './entity-tecnico-responsable.model';
import { TecnicoResponsableService } from './entity-tecnico-responsable.service';

@Injectable()
export class TecnicoResponsableEffects {
  // load
  loadRequestTecnicoResponsable = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTecnicoResponsableLoadRequest),
      mergeMap(() =>
        this.tecnicoResponsableService.getTecnicoResponsable().pipe(
          map((items) => entityTecnicoResponsableLoadSuccess({ items })),
          catchError((error) =>
            of(entityTecnicoResponsableLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestTecnicoResponsable = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTecnicoResponsableAddRequest),
      switchMap((action) =>
        this.tecnicoResponsableService.addTecnicoResponsable(action.item).pipe(
          map((item) => entityTecnicoResponsableAddSuccess({ item })),
          catchError((error) =>
            of(entityTecnicoResponsableAddFailure({ error }))
          )
        )
      )
    )
  );

  addSuccessTecnicoResponsable = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityTecnicoResponsableAddSuccess),
        tap(() => {
          this.notification.success('Técnico Responsable registrado con éxito');
          return this.router.navigate(['/main', 'landing'])
        })
      ),
    { dispatch: false }
  );

  // change
  changeRequestTecnicoResponsable = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTecnicoResponsableChangeRequest),
      switchMap((action) =>
        this.tecnicoResponsableService
          .changeTecnicoResponsable(action.item)
          .pipe(
            map((itemaux: TecnicoResponsable) => {
              // console.log(itemaux, 'itemaux');
              const item: Update<TecnicoResponsable> = {
                id: itemaux.id,
                changes: itemaux
              };
              return entityTecnicoResponsableChangeSuccess({ item });
            }),
            catchError((error) =>
              of(entityTecnicoResponsableAddFailure({ error }))
            )
          )
      )
    )
  );

  changeSuccessTecnicoResponsable = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityTecnicoResponsableChangeSuccess),
        tap(() =>
          this.notification.success(
            'Solicitud de acreditación ingresada con éxito.'
          )
        )
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private tecnicoResponsableService: TecnicoResponsableService,
    private router: Router,
    private notification: NotificationService
  ) {
    this.tecnicoResponsableService.url = environment.apiUrl;
  }
}
